const Constants = require('../constants/Constants');
const BaseStore = require('./BaseStore');

const SuppressedEmailsStore = new BaseStore({
    defaultData: {
        suppressions: [],
        saving: false,
        recentlySaved: false
    }
});

SuppressedEmailsStore.register(Constants.api.SUPPRESSED_EMAILS_LIST, function (payload) {
    const action = payload.action;

    if (action.state === Constants.request.PENDING) {
        this._loading = true;

        return true;
    }

    if (action.state === Constants.request.FINISHED) {
        this._loading = false;
        this.setData(Object.assign(this._data, {suppressions: action.response.body.suppressions, saving: false, recentlySaved: false}));

        return true;
    }
});

SuppressedEmailsStore.register(Constants.api.SUPPRESSED_EMAILS_UPDATE, function (payload) {
    const action = payload.action;
    console.log(payload);

    if (action.state === Constants.request.PENDING) {
        this.setData(Object.assign(this._data, {saving: true, recentlySaved: false}));

        return true;
    }

    if (action.state === Constants.request.FINISHED) {
        this.setData(Object.assign(this._data, {saving: false, recentlySaved: true}));

        return true;
    }
});

module.exports = SuppressedEmailsStore;



// WEBPACK FOOTER //
// ./app/stores/SuppressedEmailsStore.js